import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var RotateLeft = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M2.3 18.39c-.1 0-.2.1-.2.2v23.436c0 .1.1.2.2.2h23.5c.1 0 .1 0 .1-.1l.1-.1V18.59c0-.1-.1-.2-.2-.2H2.3Zm-2.3.2c0-1.297 1-2.294 2.3-2.294h23.6c1.3 0 2.3.997 2.3 2.294v23.536c0 1.197-1 2.294-2.3 2.294H2.3C1 44.32 0 43.323 0 42.026V18.59Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M39.4 33.749c-.4.399-1 .498-1.5.1-.4-.4-.5-.998-.1-1.496 4.6-5.286 5.5-13.065 1.6-19.348-4.7-7.68-14.8-10.073-22.5-5.286l4.5 1.097c.6.1.9.698.8 1.296-.1.599-.7.898-1.3.798l-6.6-1.595c-.6-.1-1.1-.698-.9-1.297L15 1.336c0-.698.6-.997 1.2-.897.6.1.9.698.8 1.296l-1 4.09C24.7.637 35.9 3.33 41.3 12.006c4.3 6.982 3.3 15.858-1.9 21.742Z"
  })));
});
RotateLeft.displayName = 'RotateLeft';
RotateLeft.defaultProps = {
  'aria-label': 'RotateLeft'
};
export default RotateLeft;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/RotateLeft.js
// module id = 3898
// module chunks = 11